import useTailwindConfig from './useTailwindConfig';

export default function useBreakpoints() {
    const config = useTailwindConfig();
    const breakpoints = config.theme.screens;
    let events = [];

    function whenBreakpointChanges(expression) {
        // plaats alle breakpoints in de reactieve array
        setBreakpoints();

        window.addEventListener('resize', function (e) {
            setBreakpoints();
        });
        // plaats de meegegeven functie in een array die later wordt uitgevoerd
        events.push(expression);
    }

    const triggerEvents = () => {
        events.forEach(event => event());
    };

    //-- een reactieve array
    const currentBreakpoints = new Proxy([], {
        // -- deze functies worden alleen uitgevoerd wanneer de array veranderd
        deleteProperty: function (target, property) {
            delete target[property];
            triggerEvents();
            return true;
        },
        set: function (target, property, value, receiver) {
            target[property] = value;
            triggerEvents();
            return true;
        },
    });

    const isBreakpoint = breakpoint => window.innerWidth > parseInt(breakpoints[breakpoint]);


    const setBreakpoints = () => {
        for (const [key, value] of Object.entries(breakpoints)) {
            if (isBreakpoint(key)) {
                if (!currentBreakpoints.includes(key)) {
                    currentBreakpoints.push(key);
                }
            } else {
                if (currentBreakpoints.includes(key)) {
                    const index = currentBreakpoints.indexOf(key);
                    currentBreakpoints.splice(index, 1);
                }
            }
        }
    };


    return {
        breakpoints,
        isBreakpoint,
        whenBreakpointChanges,
    };
}